import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { SHORTCUTS } from "@/lib/shortcuts";

export default function ShortcutsHelp({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Keyboard Shortcuts</DialogTitle>
          <DialogDescription>
            Use F-keys like Tally — or Alt + digit if your browser blocks the F-key.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-1 text-sm" data-testid="shortcuts-help-dialog">
          {SHORTCUTS.map((s) => (
            <div key={s.fkey} className="flex items-center justify-between py-1.5 px-2 rounded hover:bg-gray-50">
              <span className="text-gray-900 font-medium">{s.label}</span>
              <span className="flex items-center gap-1.5">
                <kbd className="tx-kbd">{s.fkey}</kbd>
                <span className="text-xs text-gray-400">or</span>
                <kbd className="tx-kbd">Alt</kbd>
                <span className="text-xs text-gray-400">+</span>
                <kbd className="tx-kbd">{s.alt}</kbd>
              </span>
            </div>
          ))}
          <div className="border-t border-gray-100 mt-2 pt-2 space-y-1">
            <div className="flex items-center justify-between py-1.5 px-2">
              <span className="text-gray-900 font-medium">Global search</span>
              <span className="flex items-center gap-1.5">
                <kbd className="tx-kbd">⌘ K</kbd>
                <span className="text-xs text-gray-400">or</span>
                <kbd className="tx-kbd">Ctrl K</kbd>
              </span>
            </div>
            <div className="flex items-center justify-between py-1.5 px-2">
              <span className="text-gray-900 font-medium">Show this help</span>
              <kbd className="tx-kbd">?</kbd>
            </div>
          </div>
          <p className="text-xs text-gray-500 mt-3 leading-relaxed">
            <strong>Note:</strong> Some browsers (Firefox, Safari) reserve F1, F5 and F7 for help, reload and caret browsing — use the Alt+digit combos in that case.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
